// extracted by mini-css-extract-plugin
export default {"tooltip_container":"styles_tooltip_container__1yNhu","tooltip_text":"styles_tooltip_text__2HI4h"};